import BaseButton from '@/components/base/BaseButton';
import BaseDrawer from '@/components/base/BaseDrawer';
import BaseLoading from '@/components/base/BaseLoading';
import { useIntl } from '@/i18n';
import type { AdminAccountDetail } from '@/types';
import { CloseOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { useState } from 'react';
import AdminPermissionDrawer from '../permission/AdminPermissionDrawer';
import AdminAccountDetailContent from './AdminAccountDetailContent';

interface AdminAccountDetailDrawerProps {
  open?: boolean;
  detail?: AdminAccountDetail;
  loading?: boolean;
  onClose: () => void;
}

/** 显示状态独立于详情数据，让等待阶段可见且可关闭。 */
export default function AdminAccountDetailDrawer(
  props: AdminAccountDetailDrawerProps,
) {
  const { open = Boolean(props.detail) } = props;
  return open ? <AccountDetail {...props} /> : null;
}

function AccountDetail({
  detail,
  loading = false,
  onClose,
}: AdminAccountDetailDrawerProps) {
  const intl = useIntl();
  const t = (id: string) => intl.formatMessage({ id });
  const [permissionId, setPermissionId] = useState<string>();
  if (detail && permissionId === detail.adminId && !loading) {
    return <AdminPermissionDrawer detail={detail} onClose={onClose} />;
  }
  return (
    <BaseDrawer
      open
      title={t('adminAcct.detail.title')}
      onClose={onClose}
      className="[&>.ant-drawer-body]:flex [&>.ant-drawer-body]:flex-col"
      footer={
        <div className="flex flex-wrap justify-end gap-2">
          <BaseButton icon={<CloseOutlined aria-hidden />} onClick={onClose}>
            {t('common.close')}
          </BaseButton>
          <BaseButton
            type="primary"
            icon={<SafetyCertificateOutlined aria-hidden />}
            disabled={loading || !detail}
            onClick={() => setPermissionId(detail?.adminId)}
          >
            {t('adminAcct.detail.permissionDetails')}
          </BaseButton>
        </div>
      }
    >
      {loading ? (
        <div className="relative flex-1 min-h-60">
          <BaseLoading overlay label={t('common.loading')} />
        </div>
      ) : detail ? (
        <AdminAccountDetailContent
          key={detail.adminId}
          detail={detail}
          onClose={onClose}
        />
      ) : null}
    </BaseDrawer>
  );
}
